import type { IMessageWriter } from '../../../engine/messageWriter'
import { messageWriter } from '../../../engine/messageWriter-sidecar'
import { websockets } from '../../../engine/websockets-sidecar'
import { assert } from '../../../lib/assert-sidecar'
import { createId } from '../../../main/common'
import { EVoyageCarryableType } from '../voyageCarryableData'
import { EVoyageCrewType } from '../voyageCrew'
import { voyageCrew } from '../voyageCrew-sidecar'
import { voyageGameStatus } from '../voyageGameStatus-sidecar'
import { voyageTilemap } from '../voyageTilemap-sidecar'
import { EBuyType } from '../voyageUiBuyStuff_data'
import { voyageWebsockets } from '../voyageWebsockets-sidecar'
import { EVoyageCrewCarryCommand } from './voyageMessageCrewCarry'
import { voyageMessageCrewCarry } from './voyageMessageCrewCarry-sidecar'
import { EVoyageCrewCreateMethod } from './voyageMessageCrewCreate'
import { voyageMessageCrewCreate } from './voyageMessageCrewCreate-sidecar'
import { EVoyageMessage } from './voyageMessageIds'
import { voyageMessageMoney } from './voyageMessageMoney-sidecar'

export interface IVoyageMessageBuyRequest {
  crewId: number
  buyType: EBuyType
  itemType: EVoyageCarryableType
  cost: number
}

export const voyageMessageId = EVoyageMessage.BuyRequest

export function write(m: IMessageWriter, d: IVoyageMessageBuyRequest) {
  messageWriter.write8(m, voyageMessageId)
  messageWriter.write32(m, d.crewId)
  messageWriter.write8(m, d.buyType)
  messageWriter.write8(m, d.itemType)
  messageWriter.writeFloat(m, d.cost)
}

export function read(m: IMessageWriter) {
  let t = messageWriter.read8(m)
  assert.eq(t, voyageMessageId)
  let d: IVoyageMessageBuyRequest = {
    crewId: messageWriter.read32(m),
    buyType: messageWriter.read8(m),
    itemType: messageWriter.read8(m),
    cost: messageWriter.readFloat(m),
  }
  return d
}

export function test() {
  let ex: IVoyageMessageBuyRequest = {
    crewId: 123,
    buyType: EBuyType.item,
    itemType: EVoyageCarryableType.Extinguisher,
    cost: 123.32,
  }
  messageWriter.test('buy-request', ex, write, read)
}

export function process(m: IMessageWriter) {
  let msg = read(m)

  // console.log('BUY!')
  if (voyageWebsockets.getIsHost()) {
    // TODO: spend money
    // console.log('BUY!1')
    //let data = voyageUiBuyStuff_data.get(msg.)

    let status = voyageGameStatus.get()
    if (msg.cost > status.money) {
      // Send error, not enough moneys
    } else {
      // console.log('BUY!2')
      if (msg.buyType === EBuyType.crew) {
        // console.log('BUY!3')
        let t = voyageTilemap.getRandomFreeSystem('tele')
        if (!t) {
          let cr = voyageCrew.findById(msg.crewId)
          assert.notNil(cr)
          voyageCrew.say(cr, 'No open teleporter!')
        }
        if (t) {
          voyageMessageMoney.sendMessageAndImmediatelyExecute({
            money: status.money - msg.cost,
          })
          voyageMessageCrewCreate.sendMessageAndImmediatelyExecute({
            crewId: createId(),
            energy: 500,
            i: t.i,
            j: t.j,
            method: EVoyageCrewCreateMethod.Teleport,
            team: 0,
            type: EVoyageCrewType.Crew,
            // name: rando
          })
        }
      }

      if (msg.buyType === EBuyType.item) {
        // console.log('BUY!4')
        let t = voyageTilemap.getRandomFreeSystem('cargo')
        if (!t) {
          let cr = voyageCrew.findById(msg.crewId)
          assert.notNil(cr)
          voyageCrew.say(cr, 'No room to buy this!')
          // console.log('could not find location!')
        }
        if (t) {
          voyageMessageMoney.sendMessageAndImmediatelyExecute({
            money: status.money - msg.cost,
          })
          voyageMessageCrewCarry.sendMessageAndImmediatelyExecute({
            command: EVoyageCrewCarryCommand.Create,
            type: msg.itemType,
            carryId1: createId(),
            carryId2: 0,
            crewId: 0,
            i: t.i,
            j: t.j,
          })
        }
      }
    }
  }
}

export function sendMessageRequest(msg: IVoyageMessageBuyRequest) {
  websockets._sendMessageRequest(write, msg)
}
